import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

type EmbaUserContextType = {
  embaUserlastName: string;
};

const EmbaUserContext = createContext<EmbaUserContextType | undefined>(
  undefined,
);

export const useEmbaUserContext = () => {
  const context = useContext(EmbaUserContext);
  if (!context) {
    throw new Error('EmbaUserContextが設定されていません。');
  }
  return context;
};

type EmbaUserProviderProps = {
  children: ReactNode;
  embaUserlastName: string;
};

export const EmbaUserProvider = ({
  children,
  embaUserlastName,
}: EmbaUserProviderProps) => {
  return (
    <EmbaUserContext.Provider value={{ embaUserlastName }}>
      {children}
    </EmbaUserContext.Provider>
  );
};
